module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-breadcrumb/theme/lui-breadcrumb.global.scss
// module id = 172
// module chunks = 0 1 11